import styles from "./styles/ButtonExpand.module.css";
import { ReactComponent as IconChevron } from "../../../assets/chevron.svg";

const ButtonExpand = ({
    CurrentState, // {Boolean} - The current state of the button (expanded or not)
    onClickFunction, // {Function} - The function to call on button click
    size, // {String} - The size of the button
    dark, // {Boolean} - Flag to indicate if the button is for dark backgrounds
}) => {
    return (
        <button
            className={`${styles.toggle_button} ${
                size === "small" ? styles.small : ""
            } ${dark ? styles.dark : ""} `}
            onClick={onClickFunction}
            type={"button"}
        >
            <span
                className={`${styles.arrow} ${
                    CurrentState === true ? styles.expanded : ""
                }`}
            >
                <IconChevron
                    className={`${styles.icon} ${
                        size === "small" ? styles.small : ""
                    } ${dark ? styles.dark : ""} icon-component`}
                />
            </span>
        </button>
    );
};

export default ButtonExpand;
